import { useParams, useLocation, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDocumentLoadCompleted } from "../Hooks";
import { AnimatePresence, motion } from "framer-motion";
import { Space } from "../Layout";

const Breadcrumb = (props) => {
  const parms = useParams();
  const isLoaded = useDocumentLoadCompleted();
  const [id, setId] = useState();
  const [bread, setBread] = useState();

  const location = useLocation();
  let pathName = location.pathname;
  pathName = pathName.replace("/", "");
  pathName = pathName.split("/");

  const style = {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  };

  useEffect(() => {
    if (pathName[0] == "post") {
      setId(parms.id ?? parms.postId);
    } else {
      fetch(`${tmp_path.site_url}/wp-json/wp/v2/pages?slug=${pathName[0]}`)
        .then((response) => response.json())
        .then((data) => {
          setId(data[0].id);
        });
    }
  }, []);

  useEffect(() => {
    fetch(`${tmp_path.site_url}/wp-json/`)
      .then((response) => response.json())
      .then((data) => {
      });
    const url = `${tmp_path.site_url}/wp-json/bcn/v1/post/${id}`;
    if (id) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          setBread(data.itemListElement);
        });
    }
  }, [id]);

  return (
    <>
      <div className="l-row">
        <Space size={['16px', '14px']}></Space>
        <ul className="list">
          <AnimatePresence>
            {bread && (
              <motion.div
                style={style}
                layout
                animate={
                  isLoaded && {
                    opacity: 1,
                    height: "auto",
                  }
                }
                initial={{
                  opacity: 0,
                  height: 0,
                }}
                exit={{
                  opacity: 0,
                }}
                transition={{
                  duration: 0.3,
                  // delay: location == '/' ? 1 : 0,
                }}
              >
                {bread.map((item, index) => {
                  const link =
                    bread.length - 1 == index ? "" : item.item["@id"];
                  // const name =
                  //   index == 0 ? 'HOME' : item.item.name;
                  return (
                    <>
                      <li
                        className="items"
                        itemprop="itemListElement"
                        itemscope
                      >
                        <Link itemprop="item" to={link}>
                          <span
                            property="itemListElement"
                            typeof="ListItem"
                            itemprop="name"
                            className="c-text__med"
                          >
                            {item.item.name}
                          </span>
                          <meta itemprop="position" content={index + 1} />
                        </Link>
                      </li>
                      {bread.length - 1 !== index && (
                        <span className="c-text__normal">&gt;</span>
                      )}
                    </>
                  );
                })}
              </motion.div>
            )}
          </AnimatePresence>
        </ul>
        <Space size={['80px', '64px']}></Space>
      </div>
    </>
  );
};

export default Breadcrumb;